import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const [pageRes, settingsRes] = await Promise.all([
        axiosInstance.get(`/api/pages/${slug}`),
        axiosInstance.get("/api/settings"),
      ]);
      setPage(pageRes.data);
      setSettings(settingsRes.data);
    } catch (err) {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  if (notFound || !page) {
    return (
      <div className="container py-5 text-center">
        <h3 className="mb-3">Page not found</h3>
        <p className="text-muted mb-4">
          This page may have been moved or unpublished.
        </p>
        <Link to="/" className="btn btn-outline-primary">
          Back to Home
        </Link>
      </div>
    );
  }

  const primaryColor = settings?.theme_primary_color || "#0d6efd";
  const imageUrl = page.featured_image_path
    ? `${process.env.REACT_APP_API_URL}/${page.featured_image_path}`
    : null;

  return (
    <div>
      <section
        className="py-4 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <div className="container">
          <h1 className="fw-bold mb-0">{page.title}</h1>
        </div>
      </section>

      <div className="container py-5">
        <div className="row g-4">
          {imageUrl && (
            <div className="col-12 col-md-4">
              <img
                src={imageUrl}
                alt={page.title}
                className="img-fluid rounded shadow-sm"
              />
            </div>
          )}
          <div className={imageUrl ? "col-12 col-md-8" : "col-12"}>
            {page.body ? (
              <p style={{ whiteSpace: "pre-line", lineHeight: 1.8 }}>
                {page.body}
              </p>
            ) : (
              <p className="text-muted">Content coming soon.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DynamicPage;
